export default __webpack_public_path__ + "static/media/heroBG.182ab521.svg";